import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpslevelComponent } from './simple-icons-opslevel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpslevelComponent ],
    exports:      [ SimpleIconsOpslevelComponent ],
    bootstrap:    []
})
export class SimpleIconsOpslevelModule {}
